import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import WhatsNewModal from './index';
import { useOncePerUser } from './useOncePerUser';

import useAuth from '@/hooks/useAuth';
import ROUTES from '@/routes/routes';

// One announcement = one key. Bump the suffix to re-announce to everyone.
const ANNOUNCEMENT_KEY = 'grv:whatsNew:save-repeat-schedule';

/**
 * "Save and repeat a schedule" What's-New announcement. Shows once per user
 * (localStorage, keyed by user id) on their first visit to any page that mounts
 * this. "Try it now" opens order creation; the X / "Check later" / backdrop /
 * Escape dismiss. All paths mark it seen so it never re-appears.
 */
const SaveScheduleAnnouncement = () => {
  const { currentAdmin } = useAuth();
  const navigate = useNavigate();

  const userId = currentAdmin?.user?.id;
  const storageKey = userId ? `${ANNOUNCEMENT_KEY}:${userId}` : null;
  const { open, markSeen } = useOncePerUser(storageKey);

  const handlePrimary = useCallback(() => {
    markSeen();
    navigate(`/${ROUTES.ordersV2}/${ROUTES.ordersV2Create}`);
  }, [markSeen, navigate]);

  return (
    <WhatsNewModal
      open={open}
      title="Save and repeat a schedule"
      description="When placing an order, you can now save your delivery schedule and reuse it anytime — no need to rebuild the same order details each time. Set it once, then repeat it on your next order with one tap."
      badgeLabel="What's New?"
      primaryLabel="Try it now"
      secondaryLabel="Check later"
      onClose={markSeen}
      onPrimary={handlePrimary}
    />
  );
};

export default SaveScheduleAnnouncement;
